export default __webpack_public_path__ + "static/media/archive.d8de803d.svg";